<body>

    <!-- HEADER -->
    <div class="header">
        <h2 translate>watch.playlist_modal.add_to_playlist_modal.title</h2>
    </div>

    <!-- CONTENT -->
    <div class="content" *ngIf="!(playlistLoading$ | async)"
        [ngStyle]="{'grid-template-rows': 'repeat(' + playlists.getValue().length/2 +' , 1fr)'}">
        <app-playlist-element *ngFor="let playlist of playlists | async" [playlist]="playlist" [selectedId]="selectedPlaylistId"
            (addToPlaylist)="addToPlaylist($event)" (elementClickEvent)="elementClick($event)">
        </app-playlist-element>
    </div>

    <div *ngIf="page < lastPage && !(playlistLoading$ | async)" class="btn-secondary" (click)="morePlaylists()" pRipple translate>
        watch.playlist_modal.add_to_playlist_modal.more-btn</div>
    <div class="content" *ngIf="playlistLoading$ | async" [ngStyle]="{'grid-template-rows': 'repeat( 2, 1fr)'}">
        <div class="playlist-element" *ngFor="let item of [0,0]">
            <p-skeleton size="3em"></p-skeleton>
            <p-skeleton width="5em"></p-skeleton>
        </div>
    </div>

    <!-- FOOTER -->
    <div class="footer">
        <div class="divider"></div>
        <div class="new_playlist_btn" (click)="createNewPlaylist()" pRipple>
            <div translate>
                <span class="icon chip-icon icon-add"></span>
                watch.playlist_modal.add_to_playlist_modal.btn
            </div>
        </div>
    </div>
</body>